import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Stack
} from 'react-bootstrap';
import { FaTwitter, FaMedium, FaLinkedin, FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import useHttpClient from '../../common/hooks/http-hook';
import './Footer.scss';

const Footer = () => {
  const [visits, setVisits] = useState(0);
  const { isLoading, error, sendRequest } = useHttpClient();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseData = await sendRequest(
          `https://api.countapi.xyz/hit/kanavs.netlify.app/${process.env.REACT_APP_COUNTAPI_KEY}`
        );
        setVisits(responseData.value);
      } catch (err) {}
    };
    fetchData();
  }, [sendRequest]);

  return (
    <div id="footer">
      <footer>
        <Row>
          <Col sm>
            <h1>Let's Connect</h1>
           
          </Col>
          <Col className="p-2" sm>
          
          </Col>
        </Row>
        <span className="divider"></span>
        <Row className="extras">
          <Col sm>
            <Stack>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScQJniQyHbx_PIGUtFidk2OSqtwr8WNhvN8SyQh-ERl46sW9g/viewform?usp=sf_link"
                target="_blank"
                rel="noreferrer noopener"
              >
               Bug Report
              </a>
              <a
                href="https://my.forms.app/kanavsharma/feedback-form"
                target="_blank"
                rel="noreferrer noopener"
              >
                Feedback Form
              </a>
            </Stack>
          </Col>
          
        </Row>
      </footer>
      <Stack className="copyright" direction="horizontal" gap={15}>
        <p>
          {' '}
          &copy; {new Date().getFullYear()} itskanav. All rights reserved.
        </p>
        <p className="ms-auto">Designed & Maintained by Kanav Sharma <br/>Made with 💖 by KANAV SHARMA</p>
        <p>v1.0.0</p>
      </Stack>
    </div>
  );
};

export default Footer;
